var app = angular.module('leonardo');

var WPFormTime = function ($timeout) {
  return {
    restrict: 'A',
    require: ['^form', 'ngModel'],
    scope: {
      disabled: '=ngDisabled',
      required: '=ngRequired',
      label: '@',
      defaultNow: '@',
      endDate: '@',
      startDate: '@'
    },
    templateUrl: 'views/templates/form/form-time.html',
    link: function (scope, element, attrs, ctrls) {
      scope.formCtrl = ctrls[0];
      scope.ngModelCtrl = ctrls[1];
      scope.$input = element.find('.form-time-input');
      scope.mask = '99:99';

      angular.element(scope.$input).mask(scope.mask);

      scope.getModelValue = function () {
        var date = scope.ngModelCtrl.$modelValue;
        if (date) {
          return moment(date, 'HH:mm').format('HH:mm');
        }
        return null;
      };

      if (scope.defaultNow) {
        scope.$input.datetimepicker({
          datepicker: false,
          timepicker: true,
          format: 'H:i',
          step: attrs.interval ? attrs.interval : 60,
          onChangeDateTime: function (dp, $input) {
            scope.date = $input.val();
            scope.ngModelCtrl.$setViewValue($input.val());
          },
          onShow: function (dp) {
            if (!scope.ngModelCtrl.$modelValue) {
              scope.ngModelCtrl.$setViewValue(dp.dateFormat('H:i'));
              scope.ngModelCtrl.$render();
              scope.$apply();
            }
          }
        });
      } else {
        scope.$input.datetimepicker({
          datepicker: false,
          timepicker: true,
          format: 'H:i',
          step: attrs.interval ? attrs.interval : 60,
          onChangeDateTime: function (dp, $input) {
            scope.ngModelCtrl.$setViewValue($input.val());
          }
        });
      }

      scope.ngModelCtrl.$render = function () {
        scope.date = scope.ngModelCtrl.$modelValue;
        scope.$input.val(scope.getModelValue());
      };

      scope.setStartDate = function (startDate) {
        let currentValue = scope.getModelValue();
        if (startDate) {
          scope.$input.datetimepicker({ minTime: startDate });
          if (scope.disabled) {
            return;
          }
          if (!currentValue) {
            return;
          }
          if (startDate >= currentValue) {
            scope.$input.val(startDate);
          } else {
            scope.$input.val(currentValue);
          }
        } else {
          scope.$input.datetimepicker({ minTime: false });
        }
      };

      scope.setEndDate = function (endDate) {
        let currentValue = scope.getModelValue();
        if (endDate) {
          scope.$input.datetimepicker({ maxTime: endDate });
          if (scope.disabled) {
            return;
          }
          if (!currentValue) {
            return;
          }
          if (endDate <= currentValue) {
            scope.$input.val(endDate);
          } else {
            scope.$input.val(currentValue);
          }
        } else {
          scope.$input.datetimepicker({ maxTime: false });
        }
      };

      scope.$watch('startDate', function (newValue) {
        scope.setStartDate(newValue);
      });

      scope.$watch('endDate', function (newValue) {
        scope.setEndDate(newValue);
      });

      scope.$watch('disabled', function (newValue) {
        if (newValue) {
          scope.$input.datetimepicker('hide');
        }
      });

      scope.$on('$destroy', function () {
        scope.$input.datetimepicker('destroy');
      });

      element.find('input').bind('keydown keypress', function (event) {
        var number = /^-?\d*$/.test(event.key);
        if (!number && event.key !== 'Backspace') {
          event.preventDefault();
        }
        $timeout(function () {
          let currentValue = scope.$input.val();
          let valid = /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(currentValue);
          if (!currentValue || (currentValue.split('_').join('').length === 5 && !valid)) {
            scope.$input.val('');
            scope.ngModelCtrl.$setViewValue('');
          }
          else if (valid) {
            if (scope.startDate && scope.startDate >= currentValue) {
              scope.$input.val(scope.startDate);
              scope.ngModelCtrl.$setViewValue(scope.startDate);
            }
            if (scope.endDate && scope.endDate <= currentValue) {
              scope.$input.val(scope.endDate);
              scope.ngModelCtrl.$setViewValue(scope.endDate);
            }
          }
        }, 1000);
      });
    }
  };
};

app.directive('wpFormTime', ['$timeout', WPFormTime]);
